(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/calendar/assets/javascripts/calendar.js') >= 0) return;  svs.modules.push('/components/components/calendar/assets/javascripts/calendar.js');

var svs = svs || {};

(function(svs) {
  'use strict';

  svs.components = svs.components || {};

  svs.components.Calendar = function(options) {
    var $el = $(options.el);
    var self;
    var datePicker;
    var enabled = true;
    var defaultDatePickerOptions = {
      today: false,
      clear: false,
      editable: false,
      close: 'Stäng',
      labelMonthNext: 'Nästa månad',
      labelMonthPrev: 'Föregående månad',
      weekdaysShort: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
      container: options.isDropDown ?
          $el.find('.js-calendar-container') :
          null,
      klass: {
        navPrev:
            'calendar-left-arrow icon-default icon-menu-left js-previous padding-xs-1 pointer',
        month: 'inline-block padding-xs-h padding-xs-v-1 f-bold',
        year: 'inline-block padding-xs-h padding-xs-v-1',
        weekdays: 'f-bold padding-xs-bottom',
        buttonClose: 'calendar-close-button',
        navNext:
            'calendar-right-arrow icon-default icon-menu-right js-next padding-xs-1 pointer',
        opened: 'picker--opened',
        picker:
            'picker ' +
            (options.dotted ? 'date-picker-dotted' : 'date-picker-default')
      },
      onRender: function() {
        setupA11y();

        if (self) {
          self.trigger('render');
        }
      },
      onSet: function(context) {
        if (self) {
          if (context.pick) {
            context = context.pick;
          }
          self.trigger('set', context);
        }
      },
      onStart: function() {
        if (self) {
          self.trigger('start');
        }
      },
      onOpen: function() {
        setupA11y();

        if (options.isDropDown) {
          $el
            .find('.js-calendar-icon')
            .removeClass('icon-menu-down')
            .addClass('icon-menu-up');
          $el
            .find('.js-calendar-content')
            .addClass('calendar-content-active');
        }
      },
      onClose: function() {
        setupA11y();

        if (options.isDropDown) {
          $el
            .find('.js-calendar-icon')
            .removeClass('icon-menu-up')
            .addClass('icon-menu-down');
          $el
            .find('.js-calendar-content')
            .removeClass('calendar-content-active');
          $el.find('.calendar').focus();
        }
      }
    };
    var datePickerOptions = $.extend(
      {},
      defaultDatePickerOptions,
      options.datePickerOptions
    );

    function init() {
      var enabled = options.enabled !== undefined ? options.enabled : true;
      initEvent();

      if (!options.lazyLoad) {
        setUpCalendar();
      }

      setEnabled(enabled);

      self.trigger('init');
    }

    function initEvent() {
      $el.on('click', toggleClick);
      $el.on('keypress', keyPress);
    }

    function setUpCalendar() {
      var $element = options.isDropDown ? $el.find('.js-calendar-input') : $el;
      var picker = $element.pickadate(datePickerOptions);

      datePicker = picker.pickadate('picker');
    }

    function setupA11y() {
      if (options.isDropDown && datePicker) {

        if (!datePicker.get('open')) {
          datePicker.$root.find('.js-previous')
            .attr('tabindex', '-1');
          datePicker.$root.find('.js-next')
            .attr('tabindex', '-1');
          datePicker.$root.find('.calendar-close-button').attr('tabindex', '-1');
          datePicker.$root.find('.picker__nav--disabled')
            .attr('tabindex', '-1')
            .attr('aria-disabled', 'true');
          datePicker.$root.find('.picker__day:not(.picker__day--disabled)')
            .attr('tabindex', '-1');
        } else {
          datePicker.$root.find('.js-previous')
            .attr('tabindex', '0')
            .one('click', function() {
              datePicker.$holder.focus();
            });
          datePicker.$root.find('.js-next')
            .attr('tabindex', '0')
            .one('click', function() {
              datePicker.$holder.focus();
            });
          datePicker.$root.find('.calendar-close-button').attr('tabindex', '0');
          datePicker.$root.find('.picker__nav--disabled')
            .attr('tabindex', '-1')
            .attr('aria-disabled', 'true');

          datePicker.$root.find('.picker__day:not(.picker__day--disabled)')
            .attr('tabindex', '0');
        }
      }
    }

    function setEnabled(enabledBool) {
      enabled = enabledBool;
      if (enabled) {
        $el.removeClass('calendar-disabled');
        $el.find('.js-calendar-title').show();
      } else {
        $el.addClass('calendar-disabled');
        $el.find('.js-calendar-title').hide();
      }
    }

    function toggleClick() {
      if (enabled) {
        if (datePicker) {
          if (datePicker.get('open')) {
            datePicker.close();
          } else {
            datePicker.open();
          }
        } else {
          setUpCalendar();
          datePicker.open();
        }
      }
      return false;
    }

    function keyPress(e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        toggleClick();
      }
    }

    function updateTitle(title) {
      $el.find('.js-calendar-title').html(title);
    }

    function getInputValue() {
      return $el.find('.js-calendar-input').val();
    }

    function setInputValue(date) {
      if (!datePicker) {
        setUpCalendar();
      }

      datePicker.set('select', date);
    }

    function setMinDate(date) {
      if (!datePicker) {
        setUpCalendar();
      }

      datePicker.set('min', date);
    }

    function setMaxDate(date) {
      if (!datePicker) {
        setUpCalendar();
      }

      datePicker.set('max', date);
    }

    function destroy() {
      $el.off('click', toggleClick);
      $el.off('keypress', keyPress);
    }

    function getDatePicker() {
      return datePicker;
    }

    self = new svs.core.Events({
      datePickerInstance: datePicker,
      datePickerOptions: datePickerOptions,
      getInputValue: getInputValue,
      setInputValue: setInputValue,
      updateTitle: updateTitle,
      setMinDate: setMinDate,
      setMaxDate: setMaxDate,
      destroy: destroy,
      setEnabled: setEnabled,
      getDatePicker: getDatePicker
    });

    init();

    return self;
  };
})(svs);


 })(window);